import { Auth } from '@aws-amplify/auth';
import SharedSessionStorage from './helpers/sharedSessionStorage';

const isDev = process.env.NODE_ENV === 'development';
const userPoolWebClientId = process.env.AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID || '';

export const authStorage = new SharedSessionStorage(userPoolWebClientId, {
  domain: isDev ? 'localhost' : 'listwithclever.com',
  secure: !isDev,
  path: '/',
  expires: 365,
  sameSite: isDev ? 'lax' : 'none',
});

Auth.configure({
  region: process.env.AWS_AMPLIFY_REGION,
  userPoolId: process.env.AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId,
  mandatorySignIn: true,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  storage: authStorage,
});
